import { createTheme, responsiveFontSizes, ThemeOptions } from '@mui/material/styles'

import szPaletteOverrides from '../../../styles/mui/szPaletteOverrides.json'
import szComponentOverrides from '../../../styles/mui/szComponentOverrides.json'
import szTypographyOverrides from '../../../styles/mui/szTypographyOverrides.json'

declare module '@mui/material/styles' {
  interface Theme {
    sz: any;
    solar: any;
  }
  interface ThemeOptions {
    sz?: any;
    solar?: any;
  }
   
  interface TypographyVariants {
    "szHeading.Regular.Small": React.CSSProperties;
    "szHeading.Regular.xSmall": React.CSSProperties;
    "szHeading.Regular.xxSmall": React.CSSProperties;
    "szHeading.Bold.xxSmall": React.CSSProperties;
    "szHeading.Bold.xSmall": React.CSSProperties;
    "szHeading.Bold.Small": React.CSSProperties;
    "szHeading.Bold.Medium": React.CSSProperties;
    "szHeading.Bold.Large": React.CSSProperties;
    "szHeading.Bold.xLarge": React.CSSProperties;
    "szHeading.Bold.xxLarge": React.CSSProperties;
    "szBody.Regular.Large": React.CSSProperties;
    "szBody.Regular.Small": React.CSSProperties;
    "szBody.Regular.xSmall": React.CSSProperties;
    "szBody.Regular.xxSmall": React.CSSProperties;
    "szBody.Regular.Medium": React.CSSProperties;
    "szBody.Medium.Small": React.CSSProperties;
    "szBody.Bold.Medium":  React.CSSProperties;
    "szBody.Bold.xSmall": React.CSSProperties; 
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    "szHeading.Regular.Small": React.CSSProperties;
    "szHeading.Regular.xSmall": React.CSSProperties;
    "szHeading.Regular.xxSmall": React.CSSProperties;
    "szHeading.Bold.xxSmall": React.CSSProperties;
    "szHeading.Bold.xSmall": React.CSSProperties;
    "szHeading.Bold.Small": React.CSSProperties;
    "szHeading.Bold.Medium": React.CSSProperties;
    "szHeading.Bold.Large": React.CSSProperties;
    "szHeading.Bold.xLarge": React.CSSProperties;
    "szHeading.Bold.xxLarge": React.CSSProperties;
    "szBody.Regular.Large": React.CSSProperties;
    "szBody.Regular.Small": React.CSSProperties;
    "szBody.Regular.xSmall": React.CSSProperties;
    "szBody.Regular.Medium": React.CSSProperties;
    "szBody.Medium.Small": React.CSSProperties;
    "szBody.Bold.Medium":  React.CSSProperties;
    "szBody.Bold.xSmall": React.CSSProperties; 
  }

}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    "szHeading.Regular.Small": true;
    "szHeading.Regular.xSmall": true;
    "szHeading.Regular.xxSmall": true;
    "szHeading.Bold.xxSmall": true;
    "szHeading.Bold.xSmall": true;
    "szHeading.Bold.Small": true;
    "szHeading.Bold.Medium": true;
    "szHeading.Bold.Large": true;
    "szHeading.Bold.xLarge": true;
    "szHeading.Bold.xxLarge": true;
    "szBody.Regular.Large": true;
    "szBody.Regular.Small": true;
    "szBody.Regular.xSmall": true;
    "szBody.Regular.xxSmall": true;
    "szBody.Regular.Medium": true;
    "szBody.Medium.Small": true;
    "szBody.Bold.Medium": true;
    "szBody.Bold.xSmall": true;
  }
}

declare module '@mui/material/LinearProgress' {
  interface LinearProgressPropsColorOverrides {
    home: true;
    solar: true;
    battery: true;
    grid: true;
    togrid: true;
    fromgrid: true;
    tobattery: true;
    frombattery: true;
  }
}



const szThemeOptions = { 
    ...szPaletteOverrides,
    ...szTypographyOverrides,
    ...szComponentOverrides,
}

const szCustomMuiTheme = responsiveFontSizes(createTheme(szThemeOptions as ThemeOptions))

export default szCustomMuiTheme